import { VehiclesImportResponse } from '../../models/vehicles-import-response';
import { VehiclesInvalidRecord } from '../../models/vehicles-invalid-record';

export function catalogVehiclesImportResponse(
  validationResult: string,
  importResult: string,
  vehicleId: string,
  data: Record<string, unknown>,
  importResponse: VehiclesImportResponse
) {
  switch (validationResult) {
    case 'OK':
      importResponse.imported += 1;
      if (importResult === 'Inserted') {
        importResponse.importInserted += 1;
      } else {
        importResponse.importUpdated += 1;
      }
      break;
    case 'EmptyVehicleId':
    case 'OverCharLimitVehicleId':
    case 'DuplicateVehicleId':
    case 'DuplicateVehicleIdInPartner':
      importResponse.invalid.push(
        new VehiclesInvalidRecord(vehicleId, 'invalid-id', data)
      );
      break;
    case 'EmptyVehicleName':
    case 'OverCharLimitVehicleName':
    case 'DuplicateVehicleName':
      importResponse.invalid.push(
        new VehiclesInvalidRecord(vehicleId, 'invalid-name', data)
      );
      break;
    default:
      importResponse.unrecoverable += 1;
      break;
  }
}
